module.exports = __webpack_public_path__ + "img/plus.bc49f08e.svg";